import { render, staticRenderFns } from "./CopyToRegister.vue?vue&type=template&id=9c02c8a8&scoped=true"
import script from "./CopyToRegister.vue?vue&type=script&lang=js"
export * from "./CopyToRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c02c8a8",
  null
  
)

export default component.exports